import { Box, Typography } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { sectionSx, TEXT } from "@/features/reassistRequests/utils/tokens";

export interface SaleInfoItem {
  label: string;
  /** 空文字・null・undefined は「-」を見せ、読み上げ用に「情報なし」を足す。 */
  value: React.ReactNode;
  emphasis?: boolean;
}

interface Props {
  items: SaleInfoItem[];
}

const isEmpty = (value: React.ReactNode): boolean =>
  value === "" || value === null || value === undefined;

/** 所在情報や確認内容の定義リスト（ラベルと値の2列）。 */
export const SaleInfoList: React.FC<Props> = ({ items }) => (
  <Box
    component="dl"
    sx={(theme) => ({
      ...sectionSx(theme),
      m: 0,
      px: 1.5,
      py: 0.5,
    })}
  >
    {items.map((item, index) => (
      <Box
        key={item.label}
        sx={(theme) => ({
          display: "grid",
          gridTemplateColumns:
            item.emphasis === true
              ? "minmax(0, 1fr)"
              : `${theme.spacing(9)} minmax(0, 1fr)`,
          columnGap: 1.5,
          rowGap: 0.25,
          py: 1,
          ...(index > 0
            ? { borderTop: `1px solid ${theme.palette.border.main}` }
            : {}),
        })}
      >
        <Typography
          component="dt"
          sx={{
            ...TEXT.meta,
            color: "text.secondary",
            overflowWrap: "anywhere",
          }}
        >
          {item.label}
        </Typography>
        <Typography
          component="dd"
          variant={item.emphasis === true ? "subtitle1" : "body2"}
          sx={{
            m: 0,
            overflowWrap: "anywhere",
            fontVariantNumeric: "tabular-nums",
            ...(item.emphasis === true ? { fontWeight: 700 } : {}),
          }}
        >
          {isEmpty(item.value) ? (
            <>
              <span aria-hidden>-</span>
              <Box component="span" sx={visuallyHidden}>
                情報なし
              </Box>
            </>
          ) : (
            item.value
          )}
        </Typography>
      </Box>
    ))}
  </Box>
);
